import { createFileRoute, Outlet } from "@tanstack/react-router";

import { MainLayout } from "@/components/layout/main-layout";

export const Route = createFileRoute("/_authed/_dashboard")({
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}
